/**
 * SOLID Review
 * S — Strong. One concern: error reporting's use case, built once.
 * O — Strong. The caps are the decision's; the wire is Infrastructure's.
 * L — N/A — no inheritance hierarchy.
 * I — Strong. Exactly the `reportClientError` op of `ClientUseCases`.
 * D — Good. Port interfaces and the shared steps, injected; what it builds is held by role (`IUseCase`).
 */
import type { IPortClientDecisions } from '../../domain/ports/ClientDecisions.contract';
import type { ICommandClientError } from '../../domain/ports/schemas/DiagnosticsMoves';
import type { IPortClientDiagnosticsServer } from '../ports/contracts';
import type { TPortOutcome } from '../ports/PortResult';
import type { IUseCase } from '../uml-components/IUseCase';
import type { ClientSteps } from '../shared/ClientSteps';
import { ReportClientErrorUseCase, type IConfigDepDiagnostics } from './ReportClientErrorUseCase';

export interface IConfigDepDiagnosticsContext {
  readonly decisions: Pick<IPortClientDecisions, 'planClientError'>;
  readonly steps: ClientSteps;
  readonly diagnostics: IPortClientDiagnosticsServer;
}

/** Error reporting (client error reporting, 2026-10-10) — the ninth context; a use case since frontend-application-oo P4. */
export class DiagnosticsContext {
  readonly reportClientError: IUseCase<ICommandClientError, TPortOutcome>;

  constructor(deps: IConfigDepDiagnosticsContext) {
    const reporting: IConfigDepDiagnostics = { decisions: deps.decisions, diagnostics: deps.diagnostics, step: deps.steps.onSession };
    this.reportClientError = new ReportClientErrorUseCase(reporting);
  }
}
